import React from "react";

function FileUploader({ attachments, setAttachments, buttonLabel }) {
  const addAttachment = () => {
    setAttachments([...attachments, null]); // add placeholder
  };

  const handleFileChange = (index, file) => {
    const newFiles = [...attachments];
    newFiles[index] = file;
    setAttachments(newFiles);
  };

  const removeAttachment = (index) => {
    const newFiles = attachments.filter((_, i) => i !== index);
    setAttachments(newFiles);
  };

  return (
    <div style={{ marginLeft: "3%" }}>
      <button type="button" className="btn" onClick={addAttachment}>
        {buttonLabel}
      </button>

      <div
        style={{
          marginTop: "10px",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        {attachments.map((file, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginTop: "5px",
              marginBottom: "15px",
            }}
          >
            <input
              type="file"
              onChange={(e) => handleFileChange(index, e.target.files[0])}
            />
            <button
              type="button"
              className="remove-btn"
              onClick={() => removeAttachment(index)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FileUploader;
